import { render, staticRenderFns } from "./norms.vue?vue&type=template&id=b7dee96c&scoped=true&"
import script from "./norms.vue?vue&type=script&lang=js&"
export * from "./norms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dee96c",
  null
  
)

export default component.exports